import { createSlice } from '@reduxjs/toolkit';
import { ENUM_GROUP_ACTION, ENUM_LOCALSTORAGE } from '../../enums/enums';
import { getLcs, setLcs } from '../../utils';

const siteSlice = createSlice({
  name: 'site',
  initialState: {
    lang: getLcs(ENUM_LOCALSTORAGE.lang, 'ru'),
    appleTouchIcon: '',
    description: '',
    favicon: '',
    groupActionType: ENUM_GROUP_ACTION.info,
    chosenGroupId: undefined
  },
  reducers: {
    setSiteLang: (state, action) => {
      setLcs(ENUM_LOCALSTORAGE.lang, action.payload);
      state.lang = action.payload;
    },
    setGroupActionType(state, action) {
      state.groupActionType = action.payload;
    },
    setChosenGroupId(state, action) {
      state.chosenGroupId = action.payload;
    }
  }
});

export default siteSlice.reducer;

export const { setSiteLang, setGroupActionType, setChosenGroupId } = siteSlice.actions;
